import React from 'react'
import PropTypes from 'prop-types'

import strings from 'utils/strings'
import { getMaskedValue } from 'components/patterns/Inputs/TimerInput/utils'
import { TIMER_MASK_HMMSSS } from 'constants/ui/timers'

import {
  StyledParagraph,
  StyledIcon,
  Container,
} from './TimerSimulatedValueDisplay.styles'

const TimerSimulatedValueDisplay = ({ value, showHintText, className }) => {
  return (
    <>
      <Container showHintText={showHintText} className={className}>
        <StyledIcon icon="simulate" fill="greyPrimary" />
        <StyledParagraph weight="bold" size="small">
          {getMaskedValue(value, TIMER_MASK_HMMSSS)}
        </StyledParagraph>
      </Container>
      {showHintText && (
        <StyledParagraph size="small" color="greyPrimary">
          {strings.timer_format_hint}
        </StyledParagraph>
      )}
    </>
  )
}

TimerSimulatedValueDisplay.propTypes = {
  value: PropTypes.number,
  showHintText: PropTypes.bool,
  className: PropTypes.string,
}

export default TimerSimulatedValueDisplay
